<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Terms of Service and End User License Agreement
      </div>
    </template>

    <ReferrerEULA />
  </content-page>
</template>

<script>
  import { ContentPage } from '@/components/pages'
  import ReferrerEULA from '@/components/documents/Referrer_EULA_2025_08_28'

  export default {
    name: 'LegalReferrerEULA',
    
    components: { ContentPage, ReferrerEULA },
  }
</script>